import en from './en.json';
import ru from './ru.json';

// eslint-disable-next-line import/no-anonymous-default-export
export default { en, ru };
